import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ExpepharmaFullscreenModule } from '@expepharma/components/fullscreen';
import { ExpepharmaLoadingBarModule } from '@expepharma/components/loading-bar';
import { ExpepharmaNavigationModule } from '@expepharma/components/navigation';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { MessagesModule } from 'app/layout/common/messages/messages.module';
import { NotificationsModule } from 'app/layout/common/notifications/notifications.module';
import { QuickChatModule } from 'app/layout/common/quick-chat/quick-chat.module';
import { SearchModule } from 'app/layout/common/search/search.module';
import { ShortcutsModule } from 'app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModernLayoutComponent } from 'app/layout/layouts/horizontal/modern/modern.component';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { SwitchModule } from 'app/layout/common/switch/switch.module';
import { BasketModule } from 'app/layout/common/basket/basket.module';
import { ExpepharmaFooterModule } from '../../footer/footer.module';

@NgModule({
    providers: [{ provide: TRANSLOCO_SCOPE, useValue: ['landing'] }],
    declarations: [ModernLayoutComponent],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        ExpepharmaFullscreenModule,
        ExpepharmaLoadingBarModule,
        ExpepharmaNavigationModule,
        LanguagesModule,
        MessagesModule,
        NotificationsModule,
        QuickChatModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule,
        TranslocoModule,
        SwitchModule,
        BasketModule,
        ExpepharmaFooterModule,
    ],
    exports: [ModernLayoutComponent],
})
export class ModernLayoutModule {}
